<template>
  <div>
    <el-container v-if="$route.meta.keepAlive">
      <Sidebar />
      <el-main>
        <Navbar />
        <router-view />
      </el-main>
    </el-container>
    <router-view v-else />
  </div>
</template>
<script>
import Sidebar from "./components/layout/sidebar";
import Navbar from "./components/layout/navbar";
export default {
  data() {
    return {};
  },
  components: {
    Sidebar,
    Navbar
  },
  methods: {}
};
</script>